import { Component, Input, OnInit } from '@angular/core';
import { ActionSheetController, ModalController, Platform, PopoverController} from '@ionic/angular';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File, FileEntry } from '@ionic-native/file/ngx';
import Bugsnag from '@bugsnag/js'
import { WebView } from '@ionic-native/ionic-webview/ngx';
import { AlertService } from '../../../services/alert.service';
import { AddressProofService } from '../../../services/address-proof.service';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-receipt-address',
  templateUrl: './receipt-address.component.html',
  styleUrls: ['./receipt-address.component.scss'],
})
export class ReceiptAddressComponent implements OnInit {
 formData  = new FormData();
 file_src:any=''
 @Input() has_transaction: boolean=false;
  optionsCamera: CameraOptions = {}
  text:any='Seleccionar'
  constructor(
     private androidPermissions: AndroidPermissions,
     private camera: Camera,
     public platform:Platform,
     private actionSheetController:ActionSheetController,
     private alertService:AlertService,
     private modalController:ModalController,
     private addressProofService:AddressProofService,
     private authService:AuthService
  ) {
   
  }
  
  ngOnInit() {}
  accept(){
    if(!this.file_src){
     this.alertService.presentToastError('Selecciona una foto para continuar.')
   }
   let file=this.file_src.split(',')[1]
  
    this.alertService.presentLoading()
    this.addressProofService.create(file).subscribe(res=>{
      this.alertService.dismissLoading()
      if(res['status'] == 200){
       this.modalController.dismiss('close')
      }else this.alertService.presentToast(res['errorMessage'])
      },err=>{
      console.log('err',err)
      this.alertService.dismissLoading()
      this.alertService.presentToast(JSON.stringify(err))
      });

  }
  omit(){
   this.modalController.dismiss('omit');
  }
  async openOptions() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Selecciona una opción',
      buttons: [
      { 
        text: 'Tomar foto',
        role: 'destructive',
        icon: 'camera-outline',          
        handler: () => {
          this.takePicture();
        }  
      },
      {
            text: 'Galería',
            icon: 'images-outline',
            handler: () => {
              this.openGallery();
            }
          },
      { text: 'Cancelar', role: 'cancel' }
     ]
    });

    await actionSheet.present();
  }

  async takePicture(){
    
    try {
      if (this.platform.is('android')) {
        await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA).then(
          result => {
            if (!result.hasPermission) {
              return this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.CAMERA);
            }
          }
        );
      }
 this.optionsCamera = {
    quality:40,
     destinationType: this.camera.DestinationType.DATA_URL,
     sourceType: this.camera.PictureSourceType.CAMERA,
     mediaType: this.camera.MediaType.PICTURE,
     correctOrientation: true,
     encodingType: this.camera.EncodingType.JPEG,
     allowEdit:false,
     saveToPhotoAlbum: false
    }
      this.camera.getPicture(this.optionsCamera).then((imageURL) => {
      this.file_src = 'data:image/jpeg;base64,' + imageURL;
         this.text='Cambiar Imagen'
      }, (err) => {
        this.alertService.presentToastError('No pudimos tomar la foto. Inténtalo de nuevo.');
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  openGallery() {
    if(this.platform.is('cordova')){
    this.optionsCamera = {
        quality: 80,
        targetWidth: 300,
        targetHeight: 300,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        correctOrientation: true,
        mediaType: this.camera.MediaType.PICTURE,
        sourceType: this.camera.PictureSourceType.SAVEDPHOTOALBUM
        }

        this.camera.getPicture(this.optionsCamera).then((imageData) => {
          this.file_src = 'data:image/jpeg;base64,' + imageData;
          this.text='Cambiar Imagen'
           }, (err) => {
        this.alertService.presentToastError('No pudimos abrir la galería. Inténtalo de nuevo.');
      });
    }
  }
  closeModal(){
   this.modalController.dismiss();
  
  }
  async selectFile(ev){
 try{
  let base64 = await this.alertService.selectFile(ev)
  if(!base64) return
    this.file_src = base64;
    this.text='Cambiar Imagen'

 }catch(e){
  console.error(e);
  this.alertService.presentToastError('No pudimos leer el archivo. Inténtalo de nuevo.');
 }
}

}
